import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateSectionMutation = createMutationHook(
  ShopRendererDraftApiClient.createSection,
  {
    mutationKey: ['createSection'],
  },
)
